<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="flex flex-wrap field-value">
      <ul
       v-if="value.length"
       class="list-disc list-inside ml-4"
      >
        <li
          v-for="(course, index) in value"
          :key="course ? course.courseId: 'courseNotFound' + index"
        >
          <NuxtLink
            :to="getCourseUrl(course)"
            :title="courseNameWithFallbacks(course)"
            class="mb-1 color-theme-light hover:color-theme-base underline transition-all duration-300 ease-in-out"
          >
            {{ courseNameWithFallbacks(course) }}
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import useCourses from '@/composables/useCourses'
import { courseNameWithFallbacks } from '@/utils/entityNames'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    question: {
      type: Object,
      required: true,
    },
  },
  setup(props, { root }) {
    const { getCourseUrl } = useCourses(root)

    return { getCourseUrl, courseNameWithFallbacks }
  },
}
</script>
